import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { HttpError, type TripView } from '@voll-intelligence/domain';

import { queryKeys } from '@web/core/query';
import { tripRepository } from '@web/data/repositories';
import { useOrgContext } from '@web/ui/core/hooks';

function isClientError(err: unknown): boolean {
  return err instanceof HttpError && err.status >= 400 && err.status < 500;
}

/** All the traveler's trips (kanban → trip-api), keyed by the card's legacy customer id. */
export function useTravelerTrips(customerId: string): UseQueryResult<TripView[]> {
  const { orgId } = useOrgContext();
  return useQuery({
    queryKey: queryKeys.trips.list(orgId, customerId),
    queryFn: () => tripRepository.listCustomerTrips(orgId, customerId),
    retry: (count, err) => !isClientError(err) && count < 1,
    retryDelay: 0,
    meta: { silent: true },
  });
}
